module.exports = __webpack_public_path__ + "static/img/zys.5674701f.png";